import { useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';
import { QuoteDetailsView } from '@pages/QuoteDetails/QuoteDetailsView';
import { QuoteWithStore } from '@store/Quote/QuoteStore';
import { ImpersonationSpeedDialControl } from '@pages/QuoteDetails/components/ImpersonationSpeedDialControl';
import { useQuote } from '@services/quotes/useQuote';

export const QuoteDetailsPage = () => {
  const { quoteId } = useParams<'quoteId'>();
  invariant(quoteId);
  const { quote } = useQuote(quoteId ?? '');

  /// FUTURE TODOS - leaving as 'scaffolding' for now (will never currently )
  // TODO don't allow on xs/sm screens
  // TODO: get secondQuoteId from url param
  // const secondQuoteId = null; // ('cmdpsd0nw02so07lpb7jsf9mo');

  // if (!secondQuoteId) {
  return (
    <QuoteWithStore quoteId={quoteId}>
      {quote?.offering?.id && (
        <ImpersonationSpeedDialControl
          quoteStatus={quote.status}
          offeringId={quote.offering.id}
          customerSubmittedOn={quote.customerSubmittedOn ?? undefined}
        />
      )}
      <QuoteDetailsView quoteId={quoteId} />
    </QuoteWithStore>
  );
  // }

  // return (
  //   <Grid spacing={2} display='flex'>
  //     <Grid size={{ xs: 12, md: 6 }} sx={{ borderRight: '2px solid pink' }}>
  //       <QuoteWithStore quoteId={quoteId}>
  //         <QuoteDetailsView quoteId={quoteId} />
  //       </QuoteWithStore>
  //     </Grid>
  //     <Grid size={{ xs: 12, md: 6 }}>
  //       <QuoteWithStore quoteId={secondQuoteId}>
  //         <QuoteDetailsView quoteId={secondQuoteId} readOnly />
  //       </QuoteWithStore>
  //     </Grid>
  //   </Grid>
  // );
};
